import { ReactFlowProvider } from '@xyflow/react';
import { memo } from 'react';

import { Flex, Save } from '@/components/core';
import { useGetAgentFromPath } from '@/hooks';

import { ExportPanelSlideOutWrapper } from './ExportPanelSlideOutWrapper.tsx';
import { FlowDiagram } from './FlowDiagram';
import { ModelPanelSlideOutWrapper } from './ModelPanelSlideOutWrapper.tsx';
import { TriggerPanelSlideOutWrapper } from './TriggerPanelSlideOutWrapper.tsx';
import { ValidationPanelSlideOutWrapper } from './ValidationPanelSlideOutWrapper.tsx';

export type IntegrationProps = object;

// eslint-disable-next-line no-empty-pattern
const IIntegration = ({}: IntegrationProps) => {
  const { data: agent, isPending: isPendingAgent } = useGetAgentFromPath();

  if (isPendingAgent) {
    return <Save message="Setting up agent builder ..." />;
  }

  if (!agent) {
    // TODO: Handle this properly
    return null;
  }

  return (
    <Flex className="h-full w-full">
      <ReactFlowProvider key={agent.agentId}>
        <FlowDiagram agentId={agent.agentId} />
        <TriggerPanelSlideOutWrapper agentId={agent.agentId} />
        <ModelPanelSlideOutWrapper agentId={agent.agentId} />
        <ValidationPanelSlideOutWrapper agentId={agent.agentId} />
        <ExportPanelSlideOutWrapper agentId={agent.agentId} />
      </ReactFlowProvider>
    </Flex>
  );
};

export const Integration = memo(IIntegration) as typeof IIntegration;
